import React from 'react';
import {NavTabs} from '~/components/Tabs';
import {businessIncentivesLinks} from '~/modules/BusinessIncentives';

export const BusinessIncentivesNavigation = () => (
    <NavTabs
        tabs={[
            {
                children: 'Expenses',
                to: businessIncentivesLinks.businessIncentives(),
                end: true,
            },
        ]}
    />
);
